/** Skeleton loading components — card, row, and grid variants with shimmer animation. */

import styles from "../../styles/skeleton.module.css";

/** Single card-shaped skeleton placeholder (150px tall). */
export function SkeletonCard() {
  return <div className={styles.card} aria-hidden="true" />;
}

/** Three-line row skeleton placeholder for list items. */
export function SkeletonRow() {
  return (
    <div className={styles.row} aria-hidden="true">
      <div className={styles.line} />
      <div className={styles.line} />
      <div className={styles.lineShort} />
    </div>
  );
}

/** Grid of skeleton cards. Defaults to 6 items in a 3-column grid. */
export function SkeletonGrid({ count = 6 }: { count?: number }) {
  return (
    <div className={styles.grid} aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={styles.gridCard} />
      ))}
    </div>
  );
}
